module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Assigned roles","message":"The user can now access and use the roles on behalf of your organization"},"da":{"title":"Roller tildelt","message":"Brugeren kan nu tilgå og bruge rollerne på vegne af din organization"}}')
  delete Component.options._Ctor
}
